import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  flags: {
    showHeadingsAndFilters: false,
    goClicked: false,
    loadingIndicatorAllIds: false,
    loadingQuestionData: false,
    loadingLPData: false,
    // loadingReportDataIds: false,
    generatingPdf: false,
    indicatorChanged: false,
    visualizationChanged: false,
    showFootnotes: true,
    // changingToMapViewWithCompareSet: false,
  },
  GSGo: {
    categoryId: '',
    category: '',
  },
  indicatorId: '',
  indicatorAllIds: [],
  lpData: [],
  questionData: [],
  tableConfigObject: [],
  chartConfigObject: [],
  stratFilters: {
    indicatorId: '',
    multistrat: '',
    yearId: '',
    stratCatId1: '',
    stratId1: '',
    stratCatId2: '',
    stratId2: '',
    responseId: '',
    dataValueTypeId: '',
    legendColumn: '',
    legendType: '',
  },
  view: 'Map',
  // reportDataIds: [],
  mapClassifierId: 'quantile',
  mapClassifierCount: 5,
  interactionType: '',
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/LP/index.js